import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-connection-dialog',
  templateUrl: './connection-dialog.component.html',
  styleUrls: ['./connection-dialog.component.css']
})
export class ConnectionDialogComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
